export const testimonials = [
  {
    id: 1,
    name: "أحمد محمد",
    role: "صاحب شركة",
    review:
      "خدمة ممتازة وسريعة جداً! تعطلت سيارتي على الطريق الصحراوي ووصلوا إلي في أقل من 30 دقيقة. الفريق محترف ومعداتهم حديثة. أنصح الجميع بالتعامل معهم.",
  },
  {
    id: 2,
    name: "فاطمة السيد",
    role: "مهندسة",
    review:
      "تجربة رائعة مع فريق ونش الانقاذ. احترافية عالية في التعامل وأسعار معقولة جداً. نقلوا سيارتي بعناية فائقة ووصلت بنفس الحالة. شكراً جزيلاً لكم.",
  },
  {
    id: 3,
    name: "محمود حسن",
    role: "رجل أعمال",
    review:
      "أفضل خدمة ونش للانقاذ في مصر بدون منافس! متاحون 24 ساعة وفعلاً يستجيبون بسرعة. تعاملت معهم أكثر من مرة ودائماً الخدمة ممتازة. ثقة مطلقة.",
  },
  {
    id: 4,
    name: "سارة إبراهيم",
    role: "طبيبة",
    review:
      "خدمة احترافية على أعلى مستوى. فريق العمل مدرب جيداً ويتعامل بلطف واحترام. الأسعار واضحة وشفافة بدون أي رسوم خفية. تجربة ممتازة حقاً.",
  },
  {
    id: 5,
    name: "خالد عبد الله",
    role: "مدير تنفيذي",
    review:
      "سرعة في الاستجابة ودقة في المواعيد. احتجت لونش في منتصف الليل وجاءوا فوراً. المعدات حديثة والخدمة احترافية. بالتأكيد سأتعامل معهم مرة أخرى.",
  },
  {
    id: 6,
    name: "نورهان أحمد",
    role: "محامية",
    review:
      "تعطلت سيارتي في منطقة بعيدة ولم أجد من يساعدني حتى اتصلت بونش الانقاذ. وصلوا بسرعة وحلوا المشكلة. فريق محترم جداً وخدمة ممتازة. شكراً لكم.",
  },
];

export default testimonials;
